module.exports = __webpack_public_path__ + "static/image-map.84fbc3a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/image-map.jpg
// module id = 475
// module chunks = 1354000900563